import React from 'react';
import { connect } from 'react-redux';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { setCampaignCanvassersLoading } from '../../store/actions';
import {
  pullCampaignCanvassers,
  updateOrCreateCanvasser,
  pullCampaignOffices,
} from '../../store/api/calls';

import { updateCampaignAggregates, getFocusedCampaign } from '../../store/api/calls';
import { canvasserEditCreateForm } from '../../utils/forms/formFields';
import { navigateAway } from '../../utils/nav';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import BaseForm from '../theme/forms/BaseForm';
import DataTable from '../theme/tables/DataTable';
import BaseModal from '../theme/modals/BaseModal';
import FeedbackTile from '../theme/modals/FeedbackTile';
import Moment from 'moment';

class CanvasserScreen extends React.Component {
  // static propTypes = {
  // 	cookies: instanceOf(Cookies).isRequired
  // };

  constructor(props) {
    super(props);

    const { cookies } = props;
    this.state = {
      editModalOpen: false,
      deleteModalOpen: false,
      editingInstance: {},
      feedbackTileVisibile: true,
      error: false,
      errMsg: '',
      // feedbackTileColor: ,
    };

    this.formInputs = canvasserEditCreateForm;
  }

  mountOrUpdatePull = () => {
    Promise.all([pullCampaignCanvassers(), pullCampaignOffices()]).then(() =>
      this.populateCreateEditFormWithOffices()
    );
  };

  componentDidMount() {
    this.mountOrUpdatePull();
  }

  componentDidUpdate(prevProps) {
    if (this.props.focusedCampaign !== prevProps.focusedCampaign) {
      this.mountOrUpdatePull();
    }
  }

  populateCreateEditFormWithOffices() {
    //this function add the offices list at the end of the form
    const res = [{ value: null, display: '' }];
    this.props.campaignOffices.forEach((d) => {
      res.push({ value: d.id, display: d.name });
    });
    this.formInputs = [...canvasserEditCreateForm];
    this.formInputs.push({
      type: 'select',
      title: 'Office',
      dataKey: 'office',
      options: res,
    });
  }

  _convertOfficeIDtoOfficeObj = (id) => {
    return this.props.campaignOffices.find((d) => d.id === id) || id;
  };

  _filterKeysForDataTable() {
    return this.props.canvassers.map((d) => ({
      //change this here. Update the table
      office:
        typeof this._convertOfficeIDtoOfficeObj(d.office) === 'object'
          ? this._convertOfficeIDtoOfficeObj(d.office).name
          : d.office,
      first_name: d.firstname,
      last_name: d.lastname,
      username: d.username,
      is_training: d.is_training ? <span className={'danger-text'}>Yes</span> : '',
      _is_training: d.is_training,
      created_on: new Moment(d.created_at).format('MM/DD/YY'),
      _created_on: new Moment(d.created_at),
      _data: d,
    }));
  }

  onOpenEditModal = (modelInstance = {}) => {
    if (modelInstance.office && typeof modelInstance.office === 'object') {
      modelInstance = { ...modelInstance, office: modelInstance.office.id };
    } else {
      modelInstance = { ...modelInstance };
    }
    this.buildInputsWithPrepopulatedFields(modelInstance);
    this.setState({ editModalOpen: true, editingInstance: modelInstance });
  };

  onCloseEditModal = () => {
    this.setState({ editModalOpen: false, editingInstance: {} });
  };

  onOpenDeleteModal = (modelInstance = {}) => {
    this.setState({ deleteModalOpen: true, editingInstance: modelInstance });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false, editingInstance: {} });
  };

  buildInputsWithPrepopulatedFields = (modelInstance) => {
    this.formInputs.forEach((d) => {
      d.value = modelInstance[d.dataKey];
    });
  };

  handleUpdateCreateSubmission = (data) => {
    const id = this.state.editingInstance.id || null;
    if (id) data = { ...data, id };
    !data.password && delete data.password;

    this.setState({ error: false });
    this.onCloseEditModal();
    updateOrCreateCanvasser(data)
      .catch((err) => {
        console.log('caught the error');
        this.setErrorMessage(err.response.data || 'Server Error');
      })
      .then(() => {
        this.props.setCampaignCanvassersLoading(false);
      });
  };

  handleRemoveSubmission = () => {
    const id = this.state.editingInstance.id;
    const data = { is_active: 0, id };

    this.setState({ error: false });
    updateOrCreateCanvasser(data).then(this.onCloseDeleteModal);
  };

  _isError = () => this.props.error || this.state.error;

  setErrorMessage = (msg) => {
    console.log('setting err message');
    this.setState({
      error: true,
      errMsg: msg,
    });

    setTimeout(() => {
      this.setState({
        error: false,
        errMsg: '',
      });
    }, 3500);
  };

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <div className="button-table-top-wrapper">
          <a className="button" onClick={this.onOpenEditModal}>
            + Create Canvasser
          </a>
        </div>
        <DataTable
          data={this._filterKeysForDataTable() || []}
          title="Canvassers"
          actions={[
            {
              title: 'edit',
              icon: 'fa-edit',
              action: (modelInstance) => this.onOpenEditModal(modelInstance),
            },
            {
              title: 'delete',
              icon: 'fa-minus-square',
              action: this.onOpenDeleteModal,
            },
          ]}
        />

        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.props.loading}
        />

        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
              {this.state.errMsg || 'There was an error.'}
            </div>
          }
          visible={this._isError()}
          classNames="danger"
        />

        <BaseModal open={this.state.editModalOpen} onClose={this.onCloseEditModal} center>
          <BaseForm
            inputs={this.formInputs}
            title={
              'Edit Canvasser:  ' +
              this.state.editingInstance.firstname +
              ' ' +
              this.state.editingInstance.lastname
            }
            onCancel={this.onCloseEditModal}
            onSubmit={this.handleUpdateCreateSubmission}
          />
        </BaseModal>

        {/*Delete Modal*/}

        <BaseModal open={this.state.deleteModalOpen} onClose={this.onCloseDeleteModal} center>
          <div className="modal-internal-wrapper">
            <p>
              Are you sure you want to remove the canvasser{' '}
              <b>
                {this.state.editingInstance.firstname} {this.state.editingInstance.lastname}
              </b>
              ?
            </p>
            <div className="button-wrapper">
              <div className="button" onClick={this.handleRemoveSubmission}>
                Remove
              </div>
              <div className="button button-outline" onClick={this.onCloseDeleteModal}>
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  focusedCampaign: state.session.focusedCampaign,
  canvassers: state.canvassers.data,
  loading: state.canvassers.loading,
  error: state.canvassers.error,
  campaignOffices: state.offices.data,
  is_admin: state.permissions.is_admin,
});

//need to move all of this functionality to the template screen.
const mapDispatchToProps = (dispatch) => ({
  setCampaignCanvassersLoading: (bool) => dispatch(setCampaignCanvassersLoading(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(CanvasserScreen));
